module.exports = __webpack_public_path__ + "img/ideation-06-bg-benchmarking.6b7c683f.png";